<template>
  <div class="job-center">
    <el-card>
      <div class="toolbar">
        <el-select
          v-model="statusFilter"
          clearable
          placeholder="全部狀態"
          style="width: 160px"
          @change="load(1)"
        >
          <el-option v-for="s in statuses" :key="s" :label="s" :value="s" />
        </el-select>
        <el-button type="primary" icon="el-icon-refresh" @click="load(page)">重新整理</el-button>
      </div>

      <el-table :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="job_no" label="任務號" width="190" />
        <el-table-column prop="kit_type" label="範本" width="130" />
        <el-table-column prop="status" label="狀態" width="110">
          <template slot-scope="{ row }">
            <el-tag :type="statusType(row.status)">{{ row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="建立時間" width="180" />
        <el-table-column prop="finished_at" label="結束時間" width="180">
          <template slot-scope="{ row }">{{ row.finished_at || '-' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="{ row }">
            <el-button size="mini" type="text" @click="openDetail(row)">詳情</el-button>
            <el-button
              v-if="canCancel(row.status)"
              size="mini"
              type="text"
              class="danger"
              @click="onCancel(row)"
            >取消</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="mt10" style="text-align: right">
        <el-pagination
          background
          layout="prev, pager, next, total"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="page"
          @current-change="load"
        />
      </div>
    </el-card>

    <el-dialog
      :visible.sync="detailVisible"
      :title="'任務詳情 #' + (detailId || '')"
      width="760px"
      :modal="false"
      append-to-body
      destroy-on-close
    >
      <JobProgress v-if="detailVisible && detailId" :job-id="detailId" hide-progress />
    </el-dialog>
  </div>
</template>

<script>
import { fetchJobs, cancelJob } from '../api/jobs'
import JobProgress from '../components/JobProgress.vue'

const STATUSES = ['pending', 'queued', 'running', 'success', 'failed', 'retrying', 'cancelled']

export default {
  name: 'JobCenter',
  components: { JobProgress },
  data() {
    return {
      statuses: STATUSES,
      list: [],
      total: 0,
      page: 1,
      pageSize: 15,
      statusFilter: '',
      detailVisible: false,
      detailId: null
    }
  },
  created() {
    this.load(1)
  },
  methods: {
    async load(page) {
      this.page = page || 1
      try {
        const data = await fetchJobs({
          page: this.page,
          pageSize: this.pageSize,
          status: this.statusFilter || undefined
        })
        this.list = data.list || []
        this.total = data.totalRow || 0
      } catch (e) {
        this.$message.error(e.message || '載入任務列表失敗')
      }
    },
    openDetail(row) {
      this.detailId = row.id
      this.detailVisible = true
    },
    canCancel(status) {
      return ['pending', 'queued', 'running', 'retrying'].indexOf(status) >= 0
    },
    async onCancel(row) {
      try {
        await this.$confirm(`確認取消任務 #${row.id} 嗎？`, '提示', { type: 'warning' })
      } catch (e) {
        return
      }
      try {
        await cancelJob(row.id)
        this.$message.success('已取消')
        this.load(this.page)
      } catch (e) {
        this.$message.error(e.message || '取消失敗')
      }
    },
    statusType(s) {
      const map = {
        success: 'success',
        failed: 'danger',
        cancelled: 'info',
        running: 'warning',
        queued: '',
        pending: ''
      }
      return map[s] || ''
    }
  }
}
</script>
